const Navigator = {}

export default Navigator
